// Time constants for timeout and session management
const MILLISECONDS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MILLISECONDS_PER_MINUTE = MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE;
const TIMEOUT_WARNING_TIME = 57 * MILLISECONDS_PER_MINUTE;  // 57 minutes
const TIMEOUT_LOGOUT_TIME = 3 * MILLISECONDS_PER_MINUTE;   // 3 minutes
const TIMEOUT_DELAY = MILLISECONDS_PER_SECOND;             // 1 second

//poll the server and tell it that we're here
function doHeartBeat() {
  const url = getContextPath() + '/eapp/heartbeat/simple';

  $.get(url, function (data) {
    doDebug(data);
  });
}

var timeoutExclusions = new Set([
  '/pf/eapp/content/demo_hub',
  '/ehp/eapp/content/demo_hub',
  '/ehp/eapp/login',
  '/ehp/eapp/logoutSuccess',
  '/pf/eapp/login',
  '/pf/eapp/logoutSuccess',
]);

//timeout is 15 but give user 3 minute warning 12 minutes equal 720000 milliseconds
function doTimeoutHandler() {
  if (!timeoutExclusions.has(location.pathname)) {
    timeoutFunction();
  }
}

function timeoutFunction() {
  const timeoutHandlerStartTime = new Date().getTime();
  const timeoutWarningTime = 720000;
  const timeoutMsTotal = 180000;
  const timeoutDelay = 1000;
  const worker = typeof Worker !== 'undefined' ? startTimeoutWorker() : null;

  let sessionTimeoutId = setTimeout(function () {
    // Show timeout modal using Bootstrap 5
    const timeoutModalEl = document.getElementById('timeoutModal');
    const timeoutModal = new bootstrap.Modal(timeoutModalEl);

    timeoutModal.show();
    timeoutModalEl.addEventListener(
      'hidden.bs.modal',
      function onModalHidden() {
        doHeartBeat();
        if (countdownTimeoutId) {
          clearTimeout(countdownTimeoutId);
        }
        killWebWorker(worker);
        doTimeoutHandler();
        timeoutModalEl.removeEventListener('hidden.bs.modal', onModalHidden);
      },
    );
    //count down
    const timeoutStartTime = new Date().getTime();
    const handlerStartTimeDiff = timeoutStartTime - timeoutHandlerStartTime;
    if (handlerStartTimeDiff >= timeoutWarningTime + timeoutMsTotal) {
      timeoutLogout();
      return;
    }

    let timeoutMin = 2;
    let timeoutSecs = 60;
    let countdownTimeoutId;

    function updateCountdown() {
      const pollTime = new Date().getTime();
      const pollDiff = pollTime - timeoutStartTime;
      let pollMin = Math.floor(
        (timeoutMsTotal + timeoutDelay) / 60000 - pollDiff / 60000,
      );
      pollMin = pollMin > 0 ? pollMin : 0;
      let pollSecs = Math.round(
        (timeoutMsTotal + timeoutDelay) / 1000 - pollDiff / 1000 - pollMin * 60,
      );

      if (pollDiff < timeoutMsTotal && (timeoutMin > 0 || timeoutSecs > 0)) {
        if (timeoutSecs == 0) {
          timeoutSecs = 60;
          timeoutMin--;
        }
        if (timeoutSecs != pollSecs) {
          timeoutSecs = pollSecs;
        }
        if (timeoutMin != pollMin) {
          timeoutMin = pollMin;
        }
        timeoutSecs--;
        const timeRemainsEl = document.getElementById('time-remains');

        if (timeRemainsEl) {
          timeRemainsEl.textContent =
            timeoutMin +
            ':' +
            (timeoutSecs < 10 ? '0' + timeoutSecs : timeoutSecs);
        }
        countdownTimeoutId = setTimeout(updateCountdown, timeoutDelay);
      } else {
        timeoutLogout();
      }
    }
    updateCountdown();
  }, timeoutWarningTime);
}

function startTimeoutWorker() {
  const worker = new Worker(
    getContextPath() + '/static/common/js/timeoutWorker.js',
  );

  worker.onmessage = function (event) {
    timeoutLogout();
  };

  return worker;
}

function killWebWorker(worker) {
  if (worker != null) {
    worker.terminate();
  }
}

// Single global reference to manage worker lifecycle
var currentTimeoutWorker = null;
function killCurrentWorker(){
    if(currentTimeoutWorker){
        try{ currentTimeoutWorker.terminate(); }catch(e){}
        currentTimeoutWorker = null;
    }
}
// TODO: set this locally with const. Using const now attempts to override global variable
var oiCSRFToken = $("meta[name='_csrf']").attr('content');

function timeoutLogout() {
  const form = document.createElement('form');
  const element1 = document.createElement('input');
  const url = getContextPath() + '/logout';

  form.method = 'POST';
  form.action = url;
  element1.value = oiCSRFToken;
  element1.name = '_csrf';
  form.appendChild(element1);
  document.body.appendChild(form);
  form.submit();
}

/**
 * Attach Call Me event to links of class 'callMe'
 * (could be called from initOIDoc)
 */
function callMeButtonPopup() {
  $('#callMe').click(function (e) {
    const $dialog = $('#popup_content');
    const xView = e.pageX - $(window).scrollLeft();
    const yView = e.pageY - $(window).scrollTop();

    $dialog.html($loading);
    $dialog.load($(this).attr('href')).dialog({
      title: getMessage('call_me.title', 'Call Me'),
      minWidth: 380,
      appendTo: '#popup_content',
      position: [xView + 10, yView + 10],
    });

    return false;
  });
}
/**
 * convert the oi:gl tags to glossary links
 */
function convertToGlossaryLinks()
{
	//find any oi:gl or oi:ml tag and turn it into a glossary url
	//<oi:gl key="glo_prescription_drugs">Coverage for Prescription Drugs</oi:gl>
  //<oi:ml key="ede.add_person.help"><i class="fas fa-question-circle"></i> Learn more about who to include.</oi:ml>
  //<oi:ml key="ede.add_person.help"><i class="fas fa-question-circle"></i> Learn more about who to include.</oi:ml>

	$("oi\\:gl").each(function() {
		let url = getContextPath()+"/eapp/glossarylookup?type=JSON&lookupTerm="+$(this).attr('key');
		 url+="&catalogId="+oiConfig.catalogId+"&clientId="+oiConfig.clientId; 
		const content = '<a class="iconGlossary" aria-label="Glossary Link" href="'+url+'">'+$(this).html()+"</a>";

    $(this).html(content);
  });

  convertOiMlToLinks();

    $("oi\\:ht").each(function() {
        const url = getContextPath()+"/eapp/messageresourcelookup?type=JSON&key="+$(this).attr('key');
		    const content = $('<a class="iconGlossary" aria-label="Learn More" href="'+url+'">'+$(this).html()+"</a>");

		    $(this).html(content);
    });
}

/**
 * load glossary links into popup model
 */
function initGlossaryLinks() {
  convertToGlossaryLinks();
  //attach glossary event listener to every link that has the icon glossary glass
  // Use event delegation so dynamically added .iconGlossary elements also get the handler
  $(document).off('click.glossaryLink', '.iconGlossary').on('click.glossaryLink', '.iconGlossary', function (e) {
    e.preventDefault();
    glossaryEventHandler($(this));

    return false;
  });
}

function glossaryEventHandler(aPopOver) {
  const triggerElement = aPopOver.get(0);
  let lHref = aPopOver.attr('href');

  if (lHref.indexOf('&clientId=') == -1) {
    lHref += '&clientId=' + oiConfig.clientId;
  }

  $.getJSON(lHref, function (data) {
    let title;
    let content;

    if (data.value) {
        const rId = aPopOver.attr('data-responder-id');
        content = typeof replaceSurveyPlaceHolderContent === 'function'
            ? replaceSurveyPlaceHolderContent(rId, data.value)
            : data.value;
        title = aPopOver.html();
    } else {
        title = data.term;
        content = data.definition;
    }

    title = title || '\u00A0'; // Use non-breaking space if title is empty to prevent Bootstrap from hiding the popover

    aPopOver.attr('title', title);
    aPopOver.attr('data-bs-content', content);

    // Use MDB popover instead of jQuery/Bootstrap popover
    try {
      // Close any other open MDB popovers first
      document
        .querySelectorAll('[data-mdb-toggle="popover"]')
        .forEach(function (elem) {
          if (elem._mdbPopover) {
            elem._mdbPopover.hide();
          }
        });

      // Set MDB popover attributes
      triggerElement.setAttribute('data-mdb-toggle', 'popover');
      triggerElement.setAttribute('data-mdb-title', aPopOver.attr('title'));
      triggerElement.setAttribute(
        'data-mdb-content',
        aPopOver.attr('data-bs-content'),
      );
      triggerElement.setAttribute('data-mdb-trigger', 'manual');
      triggerElement.setAttribute('data-mdb-html', 'true');
      triggerElement.setAttribute('data-mdb-sanitize', 'false');

      // Create and show MDB popover
      if (typeof mdb !== 'undefined' && mdb.Popover) {
        const mdbPopover = new mdb.Popover(triggerElement, {
          trigger: 'manual',
          html: true,
          sanitize: false,
        });

        // Store reference for cleanup
        triggerElement._mdbPopover = mdbPopover;

        mdbPopover.show();

        // Wait for the popover to be inserted into DOM
        setTimeout(function () {
          const popoverEl = document.querySelector('.popover');

          if (!popoverEl) {
            return;
          }

          const cleanup = function () {
            $(document).off('.glossary');
            if (triggerElement._mdbPopover) {
              triggerElement._mdbPopover.hide();
            }
            if (triggerElement) triggerElement.focus();
          };

          popoverEl.setAttribute('role', 'dialog');
          popoverEl.setAttribute('aria-live', 'polite');
          popoverEl.setAttribute('tabindex', '-1');
          popoverEl.focus();

          $(document).on('keydown.glossary', function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
              cleanup();
              aPopOver.focus();
            }
          });

          $(document).on('mousedown.glossary', function (e) {
            if (
              !$(popoverEl).is(e.target) &&
              $(popoverEl).has(e.target).length === 0 &&
              !aPopOver.is(e.target)
            ) {
              cleanup();
            }
          });
        }, 100);
      } else {
        // Fallback to Bootstrap popover if MDB is not available
        console.warn('MDB not available, falling back to Bootstrap popover');
        if (typeof bootstrap !== 'undefined' && bootstrap.Popover) {
          // Set MDB popover attributes for consistency
          triggerElement.setAttribute('data-mdb-toggle', 'popover');
          triggerElement.setAttribute('data-mdb-title', aPopOver.attr('title'));
          triggerElement.setAttribute(
            'data-mdb-content',
            aPopOver.attr('data-bs-content'),
          );
          triggerElement.setAttribute('data-mdb-trigger', 'manual');
          triggerElement.setAttribute('data-mdb-html', 'true');

          // Close any other open Bootstrap popovers
          document
            .querySelectorAll('[data-mdb-toggle="popover"]')
            .forEach(function (elem) {
              if (elem !== triggerElement && elem._bsPopover) {
                elem._bsPopover.hide();
              }
            });

          const bsPopover = new bootstrap.Popover(triggerElement, {
            trigger: 'manual',
            html: true,
            sanitize: false,
          });

          // Store reference for cleanup
          triggerElement._bsPopover = bsPopover;
          bsPopover.show();

          // Wait for the popover to be inserted into DOM
          setTimeout(function () {
            const popoverEl = document.querySelector('.popover');

            if (!popoverEl) {
              return;
            }

            const cleanup = function () {
              $(document).off('.glossary');
              if (triggerElement._bsPopover) {
                triggerElement._bsPopover.hide();
              }
              if (triggerElement) triggerElement.focus();
            };

            popoverEl.setAttribute('role', 'dialog');
            popoverEl.setAttribute('aria-live', 'polite');
            popoverEl.setAttribute('tabindex', '-1');
            popoverEl.focus();

            $(document).on('keydown.glossary', function (e) {
              if (e.key === 'Escape' || e.keyCode === 27) {
                cleanup();
                aPopOver.focus();
              }
            });

            $(document).on('mousedown.glossary', function (e) {
              if (
                !$(popoverEl).is(e.target) &&
                $(popoverEl).has(e.target).length === 0 &&
                !aPopOver.is(e.target)
              ) {
                cleanup();
              }
            });
          }, 200);
        } else {
          console.warn('Neither MDB nor Bootstrap popover available');
        }
      }
    } catch (error) {
      console.error('Error creating MDB popover:', error);
      // Fallback to Bootstrap popover on error
      if (typeof bootstrap !== 'undefined' && bootstrap.Popover) {
        // Set MDB popover attributes for consistency
        triggerElement.setAttribute('data-mdb-toggle', 'popover');
        triggerElement.setAttribute('data-mdb-title', aPopOver.attr('title'));
        triggerElement.setAttribute(
          'data-mdb-content',
          aPopOver.attr('data-bs-content'),
        );
        triggerElement.setAttribute('data-mdb-trigger', 'manual');
        triggerElement.setAttribute('data-mdb-html', 'true');

        const bsPopover = new bootstrap.Popover(triggerElement, {
          trigger: 'manual',
          html: true,
          sanitize: false,
        });
        bsPopover.show();
      } else {
        console.warn('Neither MDB nor Bootstrap popover available');
      }
    }
  });
}





/**
 * called when the page renders
 */
function initOIDoc() {
  initGlossaryLinks();

  // Initialize MDB checkbox components for existing content
  // Set in shared-ui/mdb-helpers.js
  initializeMDBComponentsForCheckboxes();
  initializeMDBComponentsForInputs();
  initializeSelects();
  initializeDatePickers();

  //cancel timeout when the button of im still here is clicked
  $('#closeTimeOutModal').click(function (e) {
    doHeartBeat();
    if (typeof countdownTimeoutId !== 'undefined' && countdownTimeoutId) {
      clearTimeout(countdownTimeoutId);
    }
    doTimeoutHandler();
  });
  //do timeout notifications as long as we're not on the timeout page
  if (location.pathname.indexOf('/eapp/timeout') == -1) {
    doTimeoutHandler();
  } //end if

  callMeButtonPopup();
}

//IOS click fix
function onClickReplace() {
  (function ($) {
    $.fn.tclick = function (onclick) {
      this.bind('touchstart', function (e) {
        onclick.call(this, e);
        e.stopPropagation();
        e.preventDefault();
      });
      this.bind('click', function (e) {
        onclick.call(this, e);
      }); //substitute mousedown event for exact same result as touchstart

      return this;
    };
  })(jQuery);
}

/**
 * switch the locale when available
 */
function switchLocaleListener() {
  $('a[class~="swithcLocale"]').click(function () {
    const url = $(this).attr('href');

    $.getJSON(url, function (data) {
      location.reload();
    });

    return false;
  });
}

const $loading =
  '<img src="' + getContextPath() + '/images/loader.gif" alt="loading" />';

// Using this over $(".datePickerBasic").daterangepicker so that it will work with dynamically added elements
$('body').on('focus',".datePickerBasic", function(){
	if ($(this).is('[readonly]')) {
		return;
	}
	$(this).daterangepicker({
		autoUpdateInput: false, //Don't pre-fill with a default before date selection
		autoApply: true,
		singleDatePicker: true,
		showDropdowns: true,
		minYear: 1901,
		maxYear: 2099,
		drops: 'auto'
	});
});
// Have to manually update on date selection when autoUpdateInput is off
$('body').on('apply.daterangepicker',".datePickerBasic", function(ev, picker){
	var $input = findInput($(this));
	$input.val(picker.startDate.format('MM/DD/YYYY'));
	$input.change(); // Fixes bootstrap material design floating label not floating
});
$('body').on('cancel.daterangepicker',".datePickerBasic", function(ev, picker){
	findInput($(this)).val('');
});

function findInput($that) {
  if ($that.prop('nodeName') == 'INPUT') {
    var $input = $that;
  } else {
    var $input = $that.closest('.input-group').find('.dateInput');
  }
  if (typeof $input === 'undefined' || $input.prop('nodeName') !== 'INPUT') {
    $input = $that.closest('.input-group').find('input.date');
  }
  return $input;
}

function changeButtonToSpinner(aButton){
  // disable button
  aButton.prop("disabled", true);
  // disable click event listeners
  aButton.css("pointer-events", "none");
  // add spinner to button
  aButton.html(
    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...'
  );
}

function changeLinkToSpinner(aLink){
    // disable button
    aLink.addClass("disabled");
    // add spinner to button
    aLink.html(
        aLink.html() + ' <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
    );
}

$(document).ready(function () {
  initOIDoc();
  switchLocaleListener();
  onClickReplace();
  applyCommonInputMasks();
  //why do we need this?
  $('a.back').click(function () {
    parent.history.back();

    return false;
  });
});
